<template>
  <div class="stock-notifier-subscribe-form">
    <div class="alt-oos-form-subscribered" v-if="Object.keys(data).length > 0">
      <p>{{ data.message }}</p>
      <button v-if="data?.already_registered" class="alt-unsubscribe-button" @click="handleUnsubscribe" :disabled="isLoading">{{ isLoading ? 'Processing...' : 'Unsubscribe' }}</button>
    </div>
    <div class="alt-oos-form-register" v-else>
      <h5>Get notified when this product is back in stock.</h5>
      <div class="fields_wrap">
        <input type="text" name="alert_email" v-model="email" class="stock-manager-email" placeholder="Notify me when available">
        <button class="stock-manager-button" name="alert_button" @click="handleSubscribe" :disabled="isLoading">{{ isLoading ? 'Processing...' : 'Send email' }}</button>
      </div>
    </div>
  </div>
  <div class="alt-oos-popup" v-if="isOpen">
    <div class="alt-oos--bg-overlay">
      <div class="alt-oos--inner">
        <div class="alt-oos-close" @click="handleClose"></div>
        <h5 class="alt-oos--heading">Thank you!</h5>
        <div class="alt-oos--des">
          <p>We will send you an email notification when your product is available.</p>
        </div>

        <section class="alt-oos-slider" v-if="related?.products">
          <OutOfStockSlider :related="related.products" :breakpoints="breakpoints" parentId="alt-oos-slider" />
        </section>

        <button class="btn-alt-oos-close" @click="handleClose">Close</button>
      </div>
    </div>
  </div>
</template>


<script setup lang="ts">
const email = ref('');
const isLoading = ref(false);
const wooStore = useWooStore();

const isOpen = ref(false);
const props = defineProps({
  pid: {
    type: String
  },
  related: {
    type: Object,
    default: null
  },
});

import OutOfStockSlider from "~/components/Product/OutOfStockSlider.vue";

interface IResponse {
  success: boolean,
  message: string,
  already_registered: boolean
}

const data = ref({} as IResponse);
const handleClose = () => {
  isOpen.value = false;
}

const breakpoints = {
    320: {
        slidesPerView: 1,
        spaceBetween: 20,
    },
    400: {
        slidesPerView: 1.5,
        spaceBetween: 20,
    },
    550: {
        slidesPerView: 2.5,
        spaceBetween: 20,
    },
    1024: {
        slidesPerView: 2.5,
        spaceBetween: 20,
    },
};

watch(() => wooStore.singleProduct.status, (newValue, oldValue) => {
  data.value = {} as IResponse;
  email.value = '';
}, { deep: true })

const handleUnsubscribe = async () => {
  isLoading.value = true;

  const { $ajax } = useNuxtApp();

  try {
    const response = await $ajax.post<IResponse>('wp-admin/admin-ajax.php', {
        action: 'alt_unsubscribe_oos',
        product_id: props.pid,
        variation_id: wooStore.singleProduct.variationId,
        email: email.value
      }, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });

    isLoading.value = false;

    if( response.success ) {
      data.value = {} as IResponse;
      alert(`${email.value} is successfully unregistered.`);
    }

  } catch (err: any) {
      console.log('err.response', err);
  }
}

const handleSubscribe = async () => {
  isLoading.value = true;
  
  const { $ajax } = useNuxtApp();

  try {
    const response = await $ajax.post<IResponse>('wp-admin/admin-ajax.php', {
        action: 'alt_subscribe_oos',
        product_id: props.pid,
        variation_id: wooStore.singleProduct.variationId,
        email: email.value
      }, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });

    isLoading.value = false;
    if( response.success ) {
      data.value = response;
      isOpen.value = true;
    }

  } catch (err: any) {
      console.log('err.response', err);
  }
}
</script>
<style lang="scss">
  @import "@/assets/scss/components/product/_out-of-stock.scss";
</style>